export default "__VITE_ASSET__D66su7xL__"